export const LOGO = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo.svg"
export const LOGO_FULL = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo_full.svg"
export const LOGO_DARK_MODE = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo-dark-mode.svg"
export const LOGO_FULL_DARK_MODE = "https://d33j98c122wnb5.cloudfront.net/antipartido/images/logo-full-dark-mode.svg"
export const HUMANWALLET_LOGO_DARK =
  "https://cdn.prod.website-files.com/64bfe0b7cf5ceb8900f47cfc/64c0d82e4f9a861231dfe614_human-wallet.svg"
export const HUMANWALLET_LOGO_LIGHT =
  "https://cdn.prod.website-files.com/64bfe0b7cf5ceb8900f47cfc/695fbcd2afff4213e3740b4c_64c0d82e4f9a861231dfe614_human-wallet%201.svg"
